export default "__VITE_ASSET__5e8aaa35__"